module.exports = {
  PersonalProfile: 'Profile',
  AuthorProfile: 'Author Profile',
  ArticlePrevious: 'Previous',
  ArticleNext: 'Next',
  second2: 's',
};
